import instantsearch from 'instantsearch.js/dist/instantsearch.production.min';
import { searchBox, hits, configure, refinementList, menuSelect, currentRefinements, clearRefinements, pagination, hitsPerPage, stats } from 'instantsearch.js/es/widgets';
import { connectPagination, connectRefinementList } from 'instantsearch.js/es/connectors';
// import { helper } from 'instantsearch.js/es/helpers'

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
const SEARCH_ONLY = import.meta.env.VITE_TYPESENSE_SEARCH_ONLY_API_KEY || '';
const SEARCH_HOST = import.meta.env.VITE_TYPESENSE_HOST || '';
const SEARCH_PORT = import.meta.env.VITE_TYPESENSE_PORT || '';
const indexName = import.meta.env.VITE_SEARCH_INDEX;

// console.log(SEARCH_ONLY);

// const searchBoxId = document.getElementById('searchbox')

// Get query from URL, e.g., ?q=your+search+term
const params = new URLSearchParams(window.location.search);
const initialQuery = params.get('content[query]') || '';
console.log(params);
console.log(initialQuery);

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
        apiKey: SEARCH_ONLY, // Be sure to use the search-only-api-key
        nodes: [
            {
                host: SEARCH_HOST,
                port: SEARCH_PORT,
                protocol: "https"
            }
        ]
    },
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  query_by is required.
    additionalSearchParameters: {
        query_by: "prioritizedSearchTerms,title,summary",
        filter_by:'handle:=news'
    }
});
const searchClient = typesenseInstantsearchAdapter.searchClient;

// const searchClient = {
//     typesenseClient,
//     search(requests) {
//         if(requests.every(({ params }) => !params.query)) {
//             return Promise.resolve({
//                 results: requests.map(() => ({
//                     hits: [],
//                     nbHits: 0,
//                     nbPages: 0,
//                     page: 0,
//                     processingTimeMS: 0,
//                     hitsPerPage: 0,
//                     exhaustiveNbHits: false,
//                     query: '',
//                     params: '',
//                     refinementList: {},
//                 })),
//             });
//         }
//
//         return typesenseClient.search(requests);
//     },
// };


// const renderWidget = {
//     render({instantSearchInstance}) {
//         const state = instantSearchInstance.renderState[indexName];
//         const query = state?.searchBox?.query?.trim();
//
//         const wrapper = document.getElementById('results-container');
//
//         if (wrapper) {
//             wrapper.style.display = query ? 'block' : 'none';
//         }
//     }
// };

const renderPagination = (renderOptions, isFirstRender) => {
    const {
        pages,
        currentRefinement,
        nbPages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
        widgetParams
    } = renderOptions;

    const { container } = widgetParams;

    if (nbPages <= 1) {
        container.style.display = 'none';
        return;
    } else {
        container.style.display = 'block';
    }

    const first = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>`;
    const previous = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`;
    const next = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>`;
    const last = `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>`;
    widgetParams.container.innerHTML = `
    <div class="query__pagination">
        <ul class="page-nav">
          ${
        !isFirstPage
            ? `
                <li>
                  <a
                    href="${createURL(0)}"
                    data-value="${0}"
                  >
                    ${first}
                  </a>
                </li>
                <li>
                  <a
                    href="${createURL(currentRefinement - 1)}"
                    data-value="${currentRefinement - 1}"
                  >
                    ${previous}
                  </a>
                </li>
                `
            : ''
    }
          ${pages
        .map(
            page => `
                <li ${currentRefinement === page ? 'class="current-page"' : ''}>
                  <a
                    href="${createURL(page)}"
                    data-value="${page}"
                  >
                    ${page + 1}
                  </a>
                </li>
              `
        )
        .join('')}
            ${
        !isLastPage
            ? `
                  <li>
                    <a
                      href="${createURL(currentRefinement + 1)}"
                      data-value="${currentRefinement + 1}"
                    >
                      ${next}
                    </a>
                  </li>
                  <li>
                    <a
                      href="${createURL(nbPages - 1)}"
                      data-value="${nbPages - 1}"
                    >
                      ${last}
                    </a>
                  </li>
                  `
            : ''
    }
        </ul>
    </div>
  `;

    [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            refine(event.currentTarget.dataset.value);
        });
    });
};

// Create the custom widget
const customPagination = connectPagination(
    renderPagination
);


const search = instantsearch({
    searchClient,
    indexName: indexName,
    routing: true,
    // routing: {
    //     router: instantsearch.routers.history(),
    //     stateMapping: {
    //         stateToRoute(uiState) {
    //             const indexUiState = uiState[indexName];
    //             return {
    //                 q: indexUiState && indexUiState.query,
    //                 page: indexUiState.page,
    //             };
    //         },
    //         routeToState(routeState) {
    //             return {
    //                 indexName: {
    //                     query: routeState.q || '',
    //                     page: routeState.page,
    //                 }
    //             };
    //         },
    //     }
    // },
});

const categoryRefinementList = (renderOptions, isFirstRender) => {
    const { items, refine } = renderOptions;
    const container = document.querySelector('#custom-refinement-list');
    container.innerHTML = `
        <ul class="search__filters">
          ${items
            .map(
                item => `
                <li class="checkbox__wrapper search__checkbox">
                <label class="checkbox__label ${item.isRefined ? 'checked' : ''}">
                  <input class="checkbox__input" type="checkbox" value="${item.value}" ${item.isRefined ? 'checked' : ''} />
                  ${item.label} (${item.count})
                  <span class="hidden${item.isRefined ? ' checked' : ''}"><i class="fa-regular fa-check"></i></span>
                </label>
                </li>`
            )
            .join('')}
        </ul>
    `;
    container.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.addEventListener('change', event => {
            refine(event.target.value);
        });
    });
};
// const priorityRefinementList = (renderOptions, isFirstRender) => {
//     const { items, refine } = renderOptions;
//     const container = document.querySelector('#priority-refinement-list');
//     container.innerHTML = `
//         <ul class="search__filters">
//           ${items
//         .map(
//             item => `
//                 <li class="checkbox__wrapper search__checkbox">
//                 <label class="checkbox__label ${item.isRefined ? 'checked' : ''}">
//                   <input class="checkbox__input" type="checkbox" value="${item.value}" ${item.isRefined ? 'checked' : ''} />
//                   ${item.label} (${item.count})
//                   <span class="hidden${item.isRefined ? ' checked' : ''}"><i class="fa-regular fa-check"></i></span>
//                 </label>
//                 </li>`
//         )
//         .join('')}
//         </ul>
//     `;
//     container.querySelectorAll('input[type="checkbox"]').forEach(input => {
//         input.addEventListener('change', event => {
//             refine(event.target.value);
//         });
//     });
// };

// 2. Create the custom widget
const customCatRefinementList = connectRefinementList(
    categoryRefinementList
);
//
// const customPriorityRefinementList = connectRefinementList(
//     priorityRefinementList
// );

// const searchInput = instantsearch.widgets.searchBox({
//     container: '#searchbox',
//     placeholder: 'Search',
//     // queryHook(query, search) {
//     //     // If it's the first page load, use the query from URL
//     //     if (initialQuery && search.helper.state.query !== initialQuery) {
//     //         search.helper.setQuery(initialQuery).search();
//     //     } else {
//     //         search(query);
//     //     }
//     // },
//     searchAsYouType: false,
//     showSubmit: false,
//     cssClasses: {
//         root: 'results__searchbar',
//         form: 'results__search',
//         input: 'results__input'
//     },
// });

const customCatRefList = customCatRefinementList({
    attribute: 'newsCategory', // must match your schema field
    searchable: false,        // optional: allows searching the list
    sortBy: ['name:asc'],    // optional: sort the facet values
});
//
// const customPriorityRefList = customPriorityRefinementList({
//     attribute: 'prioritizedSearchTerms', // must match your schema field
//     searchable: false,        // optional: allows searching the list
//     sortBy: ['name:asc'],    // optional: sort the facet values
// });

const menu = instantsearch.widgets.menuSelect({
    container: '#year-select',
    attribute: 'year', // must match your schema field
    searchable: false,        // optional: allows searching the list
    sortBy: ['name:asc'],    // optional: sort the facet values
    cssClasses: {
        select: [
            'filter__year',
        ],
    },
    templates: {
        defaultOption(data, { html }) {
            return html`<span>Year</span>`;
        },
        item(item, { html }) {
            return html`<span>${item.label} (${item.count.toLocaleString()})</span>`;
        },
    },
});

// const hitsPage = instantsearch.widgets.hitsPerPage({
//     container: '#hits-per-page',
//     items: [
//         { label: 'Limit: 10', value: 10, default: true },
//         { label: 'Limit: 20', value: 20 },
//         { label: 'Limit: 50', value: 50 },
//     ],
//     cssClasses: {
//         select: [
//             'results__filter',
//         ],
//     },
// });

// const currentRef = instantsearch.widgets.currentRefinements({
//     container: '#current-refinements',
// });
//
// const clearRef = clearRefinements({
//     container: '#clear-refinements',
//     cssClasses: {
//         root: 'search-filter-ctas',
//         button: [
//             'search-filter-ctas-button',
//         ],
//     },
// });

const searchHits = instantsearch.widgets.hits({
    container: '#hits',
    templates: {
        item(hit, { html, components }) {

            const externalImgCredit =
                hit.externalImgCredit
                    ? html`<p class="news__photo-credit">${hit.externalImgCredit}</p>`
                    : '';
            const newsSourceLogo =
                hit.newsSourceLogoSrc
                    ? html`<img src="${hit.newsSourceLogoSrc}" alt="caption goes here" class="external-source__img"/>`
                    : '';
            const nsTitle =
                hit.newsSourceTitle
                    ? html`<div class="news__external-source"><p class="external-source__title${hit.newsSourceLogoSrc ? html` visually-hidden` : ''}">${hit.newsSourceTitle}</p></div>`
                    : '';
            const newsSource =
                hit.newsSourceUrl
                    ? html`<a href="${hit.newsSourceUrl}" target="_blank" class="news__external-source">${newsSourceLogo}${nsTitle}</a>`
                    : html`${hit.newsSourceTitle ? nsTitle : ''}`;
            const imageSrc =
                hit.imageSrc
                    ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img src="${hit.imageSrc}" srcset="${hit.imageSrcset}" alt="${hit.imageAltText}" class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}" sizes="(min-width:641px) 30vw, 100vw"/></a>`
                    : '';
            const previewImgSrc =
                hit.previewImgSrc
                    ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img src="${hit.previewImgSrc}" srcset="${hit.previewImgSrcset}" alt="${hit.previewImgAltText}" class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}" sizes="(min-width:641px) 30vw, 100vw"/></a>`
                    : '';
            const externalImgSrc =
                hit.externalImgSrc
                    ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__image ${hit.handle === 'news' ? 'news-featured__image' : 'results__image-image'}"><img src="${hit.externalImgSrc}" srcset="${hit.externalImgSrcset}" alt="${hit.externalImgAltText}" class="${hit.handle === 'news' ? 'news-featured__image-image' : 'results__image-image'}" sizes="(min-width:641px) 30vw, 100vw"/>${externalImgCredit}</a>`
                    : '';
            const headshotImgSrc =
                hit.headshotImgSrc
                    ? hit.showLink === true ? html`<a href="${hit.externalUrl ? hit.externalUrl : hit.url }"><img src="${hit.headshotImgSrc}" srcset="${hit.headshotImgSrcset}" alt="${hit.headshotAltTxt}" class="people__image" sizes="(min-width:641px) 30vw, 100vw"/></a>` : html`<div><img src="${hit.headshotImgSrc}" srcset="${hit.headshotImgSrcset}" alt="${hit.headshotAltTxt}" class="people__image" sizes="(min-width:641px) 30vw, 100vw"/></div>`
                    : '';
            const parent = hit.parentUrl !== '' ? html`<p class="results__parent"><a href="${hit.parentUrl}" class="results__link">${hit.parentTitle}</a></p>` : '';
            const peopleBlock =
                hit.handle === 'people'
                    ? html `<div class="news__article-content">
                            ${headshotImgSrc ? headshotImgSrc : '' }
                            <div class="results__right">
                                ${hit.showLink === true ? html`<a href="${hit.url}" class="results__entry-title">${components.Highlight({ attribute: 'title', hit })}</a>` : html`<h3 class="results__entry-title">${components.Highlight({ attribute: 'title', hit })}</h3>` }
                                ${hit.shortBio != '' ? html`<p class="results__description">${components.Highlight({attribute: 'shortBio', hit})}</p>` : hit.personTitle != '' ? html`<p class="results__description">${components.Highlight({attribute: 'personTitle', hit})}</p>` : ''}
                            </div>
                        </div>`
                    : '';
            const contentBlock =
                html`
                    ${newsSource}
                    <div class="news__article-content">

                        ${imageSrc ? imageSrc : previewImgSrc ? previewImgSrc : externalImgSrc ? externalImgSrc : headshotImgSrc ? headshotImgSrc : '' }

                        <div class="results__right">
                            ${hit.handle !== 'news' ? html`${parent}` : '' }
                            ${hit.handle === 'news'
                                ? html`<div class="news__article-categories">${hit.newsCategory?.map((cat) => html`<a href="${cat}" class="news__article-category">${cat}</a> `)}</div>`
                                : ''
                            }
                            <a href="${hit.externalUrl ? hit.externalUrl : hit.url }" class="results__entry-title">
                              ${components.Highlight({ attribute: 'title', hit })} ${hit.externalUrl ? html`<i class="fa-regular fa-arrow-up-right-from-square external-link"></i>` : ''}
                            </a>
                            ${hit.summary != ''
                                ? html`<p class="results__description">${components.Highlight({ attribute: 'summary', hit }) }</p>`
                                : '' }
                        </div>
                    </div>
                `;
            return html`
                    ${peopleBlock ? peopleBlock : contentBlock}
                `;
        },
        empty(results, {html}) {
            if (results.query === '') return null;
            return html`No results found for "${results.query}"`;
        },
    }
});

const pageNav = instantsearch.widgets.pagination({
    container: '#pagination',
    cssClasses: {
        root: 'query__pagination',
        list: 'page-nav',
        selectedItem: 'current-page',
    },
    templates: {
        first() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"/></svg>`
        },
        previous() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>`
        },
        next() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>`
        },
        last() {
            return `<svg class="svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>`
        },

    },
});

// const searchStats = instantsearch.widgets.stats({
//     container: '#stats',
//     cssClasses: {
//         root: 'results__stats',
//     },
// })

const config = instantsearch.widgets.configure({
    query: initialQuery,
    hitsPerPage: 10
});

search.addWidgets([
    customCatRefList,
    menu,
    searchHits,
    pageNav,
    config,
    customPagination({
        container: document.querySelector('#pagination'),
    })
]);

search.start();

// console.log(search.renderState[indexName].searchBox);
// console.log(search.renderState[indexName].searchBox.query);

//
// import Typesense from 'typesense';
// //
// // const SEARCH_ONLY = import.meta.env.VITE_TYPESENSE_SEARCH_ONLY_API_KEY || '';
// // const SEARCH_HOST = import.meta.env.VITE_TYPESENSE_HOST || '';
// // const SEARCH_PORT = import.meta.env.VITE_TYPESENSE_PORT || '';
// const searchTermIndex = import.meta.env.VITE_SEARCH_TERM_INDEX;
//
// console.log(SEARCH_ONLY);
//
// const typesense = new Typesense.Client({
//     nodes: [
//         {
//             host: SEARCH_HOST,
//             port: SEARCH_PORT,
//             protocol: "https"
//         }
//     ],
//     apiKey: SEARCH_ONLY,
//     connectionTimeoutSeconds: 2
// });
//
// async function getTopSearchTerms() {
//     const result = await typesense.collections(searchTermIndex).documents().search({
//         q: '*',
//         query_by: 'term',
//         sort_by: 'count:desc',
//         per_page: 20
//     });
//
//     return result.hits
//         .map(hit => hit.document.term.trim())
//         .filter(term => term.length > 0);
// }
//
// getTopSearchTerms().then(terms => {
//     const container = document.getElementById('top-search-tags');
//     const createSearchHref = (term) => {
//         const url = new URL(window.location.href);
//         url.searchParams.set('content[query]', term);
//         return url.toString();
//     };
//     terms.forEach(term => {
//         const tag = document.createElement('a');
//         tag.textContent = term;
//         tag.className = 'top-search-tag';
//         tag.href = createSearchHref(term);
//         tag.onclick = () => {
//             event.preventDefault();
//             search.helper.setQuery(term).search();
//         };
//
//         const listItem = document.createElement('li');
//         listItem.appendChild(tag)
//
//         container.appendChild(listItem);
//     });
// });

document.getElementById('reset-search').addEventListener('click', function () {
    search.setUiState({
        [search.indexName]: {
            refinementList: {},
            page: 0
        }
    });
});

// CLEAR EVERYTHING FROM THE SEARCHBOX RESET BUTTON;
// document.querySelector('.ais-SearchBox-reset').addEventListener('click', function () {
//     search.setUiState({
//         [search.indexName]: {
//             query: '',
//             refinementList: {},
//             page: 0
//         }
//     });
// });
// const searchFormInput = document.querySelector('.ais-SearchBox-input');
// const searchReset = document.querySelector('.ais-SearchBox-reset');
// const searchSuggestions = document.querySelector('#search-suggestions');
//
// let searchQuery = '';
// searchFormInput.addEventListener('input', (e) => {
//    const searchQuery = e.target.value;
//     console.log(searchQuery);
//     if(searchQuery) {
//         searchSuggestions.style.display = 'none';
//     }
// });
//
// if(initialQuery != '') {
//     searchSuggestions.style.display = 'none';
// }

// CLEAR EVERYTHING FROM THE SEARCHBOX RESET BUTTON;

// searchReset.addEventListener('click', function () {
//     searchSuggestions.style.display = 'block';
//     searchQuery = '';
//     search.setUiState({
//         [search.indexName]: {
//             query: '',
//             refinementList: {},
//             page: 0
//         }
//     });
//
// });


const icon = document.getElementsByClassName('search__mobile-icon')[0]
const filterArea = document.getElementsByClassName('news__right')[0]
// console.log(filterArea.classList)
icon.addEventListener('click', () => {
    if (filterArea.classList.contains('active')) {
        filterArea.classList.remove('active')
        icon.setAttribute('aria-expanded', 'false')
    }
    else {
        filterArea.classList.add('active')
        icon.setAttribute('aria-expanded', 'true')
    }
})
icon.addEventListener('keypress', (e) => {
    if (e.charCode === 13)
        if (filterArea.classList.contains('active')) {
            filterArea.classList.remove('active')
            icon.setAttribute('aria-expanded', 'false')
        }
        else {
            filterArea.classList.add('active')
            icon.setAttribute('aria-expanded', 'true')
        }
})